import { render, staticRenderFns } from "./CustomLists.vue?vue&type=template&id=aba967d4&scoped=true&"
import script from "./CustomLists.vue?vue&type=script&lang=js&"
export * from "./CustomLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aba967d4",
  null
  
)

export default component.exports